export default "__VITE_ASSET__4b2f9c5c__"